var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "is-loading"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('vue-timepicker', {
    staticClass: "app-time-picker",
    class: {
      'app-time-picker--is-invalid': _vm.hasError
    },
    attrs: {
      "placeholder": _vm.placeholder,
      "format": "HH:mm",
      "hour-label": "時",
      "minute-label": "分",
      "input-class": ['form-control'],
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.time,
      callback: function callback($$v) {
        _vm.time = $$v;
      },
      expression: "time"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }